import { IPublicClientApplication } from '@azure/msal-browser';
import { AwardJudge } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  assignAwardJudge,
  assignCountryAwardJudge,
  getAvailableJudges,
  getAwardJudges,
  getCountryAwardJudges,
  getCountryJudgeAssignedNomination,
  getJudgeAssignedNomination,
  getPreviewNextNomination,
} from './index';

export const createStaffAwardsJudgesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardJudges: (instance: IPublicClientApplication, awardId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardJudges(fetchContext, awardId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardJudges', isInFlight);
    },
  ),
  getCountryAwardJudges: (instance: IPublicClientApplication, awardId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryAwardJudges(fetchContext, awardId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryAwardJudges', isInFlight);
    },
  ),
  assignAwardJudge: (instance: IPublicClientApplication, awardId: number, judge: AwardJudge) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => assignAwardJudge(fetchContext, awardId, judge, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('assignAwardJudge', isInFlight);
    },
  ),
  assignCountryAwardJudge: (instance: IPublicClientApplication, awardId: number, countryId: number, judge: AwardJudge) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => assignCountryAwardJudge(fetchContext, awardId, countryId, judge, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('assignCountryAwardJudge', isInFlight);
    },
  ),
  getAvailableJudges: (instance: IPublicClientApplication, awardId: number, nominationId: number, includeGroupLead: boolean, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAvailableJudges(fetchContext, awardId, nominationId, includeGroupLead, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableJudges', isInFlight);
    },
  ),
  getJudgeAssignedNomination: (instance: IPublicClientApplication, awardId: number, userId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getJudgeAssignedNomination(fetchContext, awardId, userId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getJudgeAssignedNomination', isInFlight);
    },
  ),
  getCountryJudgeAssignedNomination: (instance: IPublicClientApplication, awardId: number, userId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryJudgeAssignedNomination(fetchContext, awardId, userId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryJudgeAssignedNomination', isInFlight);
    },
  ),
  getPreviewNextNomination: (instance: IPublicClientApplication, awardId: number, userId: number, viewedNominationId?: number, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getPreviewNextNomination(fetchContext, awardId, userId, viewedNominationId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getPreviewNextNomination', isInFlight);
    },
  ),
});
